import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import lt from "./lt";

Vue.use(Vuetify);

export default new Vuetify({
	lang: {
		locales: {lt},
		current: "lt"
	}
});
